import i18next from "src/i18n/config";
import { MinimalTableCell } from "src/ui/shared/table/MinimalTableComponents";
import { Tooltip } from "src/ui/shared/Tooltip";

import { Typography } from "@mui/material";
import { createColumnHelper } from "@tanstack/react-table";

export type FormValues = {
    workspaceId?: number;
    name?: string;
    title?: string;
    url?: string;
};

const columnHelper = createColumnHelper<API.FdroidRepoAdmin>();

export const tableColumns = [
    columnHelper.accessor("name", {
        id: "name",
        header: i18next.t("common:label.name"),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("title", {
        id: "title",
        header: i18next.t("common:label.title"),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("url", {
        id: "url",
        header: i18next.t("common:label.url"),
        cell: (info) => (
            <MinimalTableCell style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                <Tooltip title={info.getValue() ?? ""} placement="top">
                    <Typography noWrap>{info.getValue()}</Typography>
                </Tooltip>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("workspaceName", {
        id: "workspaceName",
        header: i18next.t("common:label.workspace"),
        cell: (info) => (
            <MinimalTableCell>
                <Tooltip title={info.row.original.workspaceGuid ?? ""} placement="top">
                    <Typography>{info.getValue()}</Typography>
                </Tooltip>
            </MinimalTableCell>
        ),
        enableSorting: false,
    }),
];

export function isFilterApplied(filterState: FormValues): boolean {
    if (filterState.workspaceId) {
        return true;
    }
    if (filterState.name) {
        return true;
    }
    if (filterState.title) {
        return true;
    }
    if (filterState.url) {
        return true;
    }
    return false;
}
